import axios from '@ts/utils/axios';

export const name = (promocode, params = {}) =>
    axios
        .get('/promo-code/name', {
            params: {
                promocode,
                ...params,
            },
        })
        .then(({ data }) => data);

export const apply = (params = {}) =>
    axios
        .get('/promo-code/apply', {
            params,
        })
        .then(({ data }) => data);

export const remove = (params = {}) =>
    axios
        .get('/promo-code/remove', {
            params,
        })
        .then(({ data }) => data);

export const activity = (promocode, ids = [], params = {}, rest = {}) =>
    axios
        .get('/promo-code/activity', {
            params: {
                promocode,
                ids: Array.isArray(ids) ? ids.join(',') : ids,
                ...params,
            },
            rest,
        })
        .then(({ data }) => {
            if (Array.isArray(data)) {
                return data;
            }

            return [];
        });
